import React, { memo }  from 'react'
import { useTranslation } from 'react-i18next'

import Dropdown from '../../dropdown'
import { languages } from '../../../i18n'
import { EHeaderStateActionTypes, withHeaderStoreValue, HeaderDispatchAction } from '../store';

interface ILanguageMenuButtonCoreHeaderStoreProps {
    showLanguages: boolean
    dispatch: HeaderDispatchAction
}

const LanguageMenuButtonCore: React.FC<ILanguageMenuButtonCoreHeaderStoreProps> = memo(({ showLanguages, dispatch }) => {
    const { i18n: { languages: [language] } } = useTranslation();

    const setShowLanguages = (value: boolean) => dispatch({ type: EHeaderStateActionTypes.UpdateShowLanguages, value })

    const currentLanguage = languages.find(item => item.code === language) || languages[0]
    const theOtherLanguages = languages.filter(item => item.code !== language)
    
    return (
        <div className="language-dropdown">
            <Dropdown
                buttonElements={
                    <span>
                        <img src={currentLanguage.iconPath} className="" alt={currentLanguage.name} />
                    </span>
                }
                dropdownContent={
                    <ul className={'language-list'}>
                        {theOtherLanguages.map(({ name, iconPath, code }) => (
                            <li key={code}><a href={`/${code}`}><img src={iconPath} alt={name} /> {name}</a></li>
                        ))}
                    </ul>
                }
                showMenu={showLanguages}
                setShowMenu={setShowLanguages}
            />
        </div>
    )
})

export const LanguageMenuButton = withHeaderStoreValue<ILanguageMenuButtonCoreHeaderStoreProps>(LanguageMenuButtonCore, ['dispatch', 'showLanguages'])